<template>
  <b-container fluid>
    <b-row>
      <b-col xl="12" sm="12">
        <iq-card>
          <template v-slot:body>
            <b-row class="details">
                <b-col lg="12" sm="12">
                    <b-row>
                        <b-col xs="12" sm="12" md="12" class="text-right mb-2">
                              <b-button class="text-right" @click="pdfExport()" variant="success">{{  $t('globalTrans.export_pdf') }}</b-button>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col xl="12" sm="12">
                            <b-row>
                                <b-col md=12>
                                    <b-table-simple striped bordered small hover>
                                        <tbody>
                                            <b-tr>
                                                <b-th colspan="6"><h5 class="text-white text-center" style="font-size: 15px; background-color: #005B5B; padding: 2px">{{ $t('externalUser.institute_info') }}</h5></b-th>
                                            </b-tr>
                                            <b-tr>
                                                <b-th width="20%">{{ $t('grant_config.organization') }}</b-th>
                                                <b-td>{{ (currentLocale === 'en') ? profile.org_name : profile.org_name_bn }}</b-td>
                                                <b-th width="20%">{{ $t('externalUser.application_type') }}</b-th>
                                                <b-td>{{ (currentLocale === 'en') ? profile.application_type : profile.application_type_bn }}</b-td>
                                            </b-tr>
                                             <b-tr>
                                                <b-th>{{ $t('externalUser.institute_type') }}</b-th>
                                                <b-td>{{ getInstituteType(profile.ins_type) }}</b-td>
                                                <b-th>{{ $t('grant_registration.institution_name') }}</b-th>
                                                <b-td>{{ (currentLocale === 'en') ? profile.ins_name : profile.ins_name_bn }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-th>{{ $t('grant_config.service_type') }}</b-th>
                                                <b-td>{{ (currentLocale === 'en') ? profile.service_type : profile.service_type_bn }}</b-td>
                                                <b-th>{{ $t('grant_config.service_name') }}</b-th>
                                                <b-td>{{ (currentLocale === 'en') ? profile.service_name : profile.service_name_bn }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-th colspan="6"><h5 class="text-white text-center" style="font-size: 15px; background-color: #005B5B; padding: 2px">{{ $t('externalUser.address') }}</h5></b-th>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{ $t('org_pro.area_type') }}</b-td>
                                                <b-td>{{ getAreaType(profile.area_type_id) }}</b-td>
                                                <b-td>{{ $t('org_pro_division.division') }}</b-td>
                                                <b-td>{{ getDivisionName(profile.division_id) }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{ $t('org_pro_district.district') }}</b-td>
                                                <b-td>{{ getDistrictName(profile.district_id) }}</b-td>
                                                <b-td>{{ $t('org_pro_upazilla.upazilla') }}</b-td>
                                                <b-td>{{ profile.upazila_id ? getUpazilaName(profile.upazila_id) : 'N/A' }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{ $t('org_pro_union.union') }}</b-td>
                                                <b-td>{{ profile.union_id ? getUnionName(profile.union_id) : 'N/A' }}</b-td>
                                                <b-td>{{ $t('org_pro.city_corporation') }}</b-td>
                                                <b-td>{{ profile.city_corporation_id ? getCityCorpName(profile.city_corporation_id) : 'N/A' }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{ $t('educational_management.pourosoba') }}</b-td>
                                                <b-td>{{ profile.paurasabha_id ? getPourosobaName(profile.paurasabha_id) : 'N/A' }}</b-td>
                                                <b-td>{{ $t('org_pro.ward') }}</b-td>
                                                <b-td>{{ profile.ward_id ? getWardName(profile.ward_id) : 'N/A' }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-th>{{ $t('externalUser.address') }}</b-th>
                                                <b-td colspan="3">{{ (currentLocale === 'en') ? profile.address : profile.address_bn }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-th colspan="6"><h5 class="text-white text-center" style="font-size: 15px; background-color: #005B5B; padding: 2px">{{ $t('externalUser.respo_personal') }}</h5></b-th>
                                            </b-tr>
                                            <b-tr>
                                                <b-th>{{ $t('globalTrans.name')}}</b-th>
                                                <b-td>{{ (currentLocale === 'en') ? profile.respo_name_en : profile.respo_name_bn }}</b-td>
                                                <b-th>{{ $t('globalTrans.designation')}}</b-th>
                                                <b-td>{{ (currentLocale === 'en') ? profile.respo_designation_en : profile.respo_designation_bn }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-th>{{ $t('externalUser.nid_no')}}</b-th>
                                                <b-td>{{ profile.respo_nid }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-th colspan="2">{{ $t('externalUser.respo_nid_attach') }}</b-th>
                                                <b-td colspan="4">
                                                <a v-if="profile.respo_nid_attach" :href="grantAllowanceServiceBaseUrl + 'storage'+ '/grant-panel' + '/institution-registration/' + profile.respo_nid_attach"
                                                target="_blank" rel="noopener noreferrer">{{ profile.respo_nid_attach }}<i class="ri-download-cloud-line" ></i>
                                                </a>
                                                </b-td>
                                            </b-tr>
                                            </tbody>
                                    </b-table-simple>
                                    <b-table-simple striped bordered small hover>
                                        <tbody>
                                            <b-tr>
                                                <b-th colspan="6"><h5 class="text-white text-center" style="font-size: 15px; background-color: #005B5B; padding: 2px">{{ $t('externalUser.others') }}</h5></b-th>
                                            </b-tr>
                                            <b-tr>
                                                <b-th width="30%">{{ $t('externalUser.office_type') }}</b-th>
                                                 <b-td>{{ getOfficeType(profile.office_type_id) }}</b-td>
                                                 <b-th width="35%">{{ $t('externalUser.office_name') }}</b-th>
                                                <b-td width="15%">{{ profile.office_id ? getOfficeName(profile.office_id) : 'N/A' }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-th>{{ $t('externalUser.institution_registration_no') }}</b-th>
                                                <b-td>{{ profile.reg_no }}</b-td>
                                                 <b-th>{{ $t('externalUser.registration_date') }}</b-th>
                                                <b-td v-if="profile.reg_date">{{ profile.reg_date | dateFormat }}</b-td>
                                                <b-td v-else></b-td>
                                            </b-tr>
                                              <b-tr>
                                                <b-th>{{ $t('externalUser.land_amount_and_source_of_receipt') }}</b-th>
                                                <b-td>{{ profile.land_amount }}</b-td>
                                                 <b-th>{{ $t('externalUser.details_of_real_estate') }}</b-th>
                                                <b-td>{{ (currentLocale === 'en') ? profile.details_of_re : profile.details_of_re_bn }}</b-td>
                                              </b-tr>
                                               <b-tr>
                                                <b-th>{{ $t('externalUser.type_wise_number_of_residence') }} :</b-th>
                                                 <b-td v-if="profile.num_of_residence_male > 0">  <span class="font-weight-bold">{{ $t('globalTrans.boy') }} : </span> {{ $n(profile.num_of_residence_male) }}</b-td>
                                                 <b-td v-if="profile.num_of_residence_female > 0"><span class="font-weight-bold">{{ $t('globalTrans.girl') }} : </span> {{ $n(profile.num_of_residence_female) }}</b-td>
                                                 <b-td v-if="profile.num_of_residence_fixed > 0"> <span class="font-weight-bold">{{ $t('globalTrans.mixed') }} : </span> {{ $n(profile.num_of_residence_fixed) }}</b-td>
                                              </b-tr>
                                             <b-tr>
                                                <b-th>{{ $t('externalUser.total_residence') }}</b-th>
                                                <b-td :colspan="profile.application_type == 1 ? 1 : 3">{{ $n(profile.total_residence) }}</b-td>
                                                <b-th v-if="profile.application_type == 1">{{ $t('externalUser.grant_application_no') }}</b-th>
                                                <b-td v-if="profile.application_type == 1">{{ $n(profile.grant_application_no) }}</b-td>
                                             </b-tr>
                                             <b-tr v-if="profile.application_type == 2">
                                                <b-th>{{ $t('externalUser.capitation_grant_received') }}</b-th>
                                                <b-td>{{ $n(profile.grant_received) }}</b-td>
                                                <b-th>{{ $t('externalUser.extension_request_no') }}</b-th>
                                                <b-td>{{ $n(profile.extension_req_no) }}</b-td>
                                             </b-tr>
                                             <b-tr v-if="profile.approve_quantity">
                                                <b-th>{{ $t('grant_registration.approved_qty') }}</b-th>
                                                <b-td colspan="3">{{ $n(profile.approve_quantity) }}</b-td>
                                             </b-tr>
                                              <b-tr>
                                                <b-th>{{ $t('externalUser.whether_the_resident_has_an_admission_register') }}</b-th>
                                                <b-td>{{ getAnswerName(profile.admission_register) }}</b-td>
                                                 <b-th>{{ $t('externalUser.whether_the_resident_has_an_attendance_register') }}</b-th>
                                                <b-td>{{ getAnswerName(profile.attendance_register) }}</b-td>
                                             </b-tr>
                                             <b-tr>
                                                <b-th>{{ $t('externalUser.whether_the_resident_has_an_leave_register') }}</b-th>
                                                <b-td>{{ getAnswerName(profile.leave_register) }}</b-td>
                                                <b-th>{{ $t('externalUser.recorded_bill_voucher') }}</b-th>
                                                <b-td>{{ getAnswerName(profile.bill_voucher)}}</b-td>
                                             </b-tr>
                                            <b-tr>
                                                <b-th>{{ $t('externalUser.last_fiscal_year_audit') }}</b-th>
                                                <b-td>{{ getAnswerName(profile.fis_year_audit) }}</b-td>
                                                <b-th>{{ $t('externalUser.last_committee_approval') }}</b-th>
                                                <b-td>{{ getAnswerName(profile.committee_approval) }}</b-td>
                                             </b-tr>
                                             <b-tr>
                                                <b-th>{{ $t('externalUser.last_committee_approval_date') }}</b-th>
                                                <b-td v-if="profile.committee_approval_date">{{ profile.committee_approval_date | dateFormat }}</b-td>
                                                <b-td v-else></b-td>
                                                <b-th>{{ $t('externalUser.bank_name') }}</b-th>
                                                <b-td>{{ bankName }}</b-td>
                                             </b-tr>
                                             <b-tr>
                                                <b-th>{{ $t('externalUser.branch_name') }}</b-th>
                                                <b-td>{{ branchName }}</b-td>
                                                <b-th>{{ $t('externalUser.account_no') }}</b-th>
                                                <b-td>{{ profile.acc_no }}</b-td>
                                             </b-tr>
                                             <b-tr v-if="profile">
                                                <b-th colspan="2">{{ $t('externalUser.ins_reg_attach') }}</b-th>
                                                <b-td colspan="4">
                                                <a v-if="profile.ins_reg_attach" :href="grantAllowanceServiceBaseUrl + 'storage'+ '/grant-panel' + '/institution-registration/' + profile.ins_reg_attach"
                                                target="_blank" rel="noopener noreferrer">{{ profile.ins_reg_attach }}<i class="ri-download-cloud-line" ></i>
                                                </a>
                                                </b-td>
                                            </b-tr>
                                            <b-tr v-if="profile">
                                                <b-th colspan="2">{{ $t('externalUser.last_committee_attach') }}</b-th>
                                                <b-td colspan="4">
                                                <a v-if="profile.last_committee_attach" :href="grantAllowanceServiceBaseUrl + 'storage'+ '/grant-panel' + '/institution-registration/' + profile.last_committee_attach"
                                                target="_blank" rel="noopener noreferrer">{{ profile.last_committee_attach }}<i class="ri-download-cloud-line" ></i>
                                                </a>
                                                </b-td>
                                            </b-tr>
                                            <b-tr v-if="profile">
                                                <b-th colspan="2">{{ $t('externalUser.last_audit_attach') }}</b-th>
                                                <b-td colspan="4">
                                                <a v-if="profile.last_audit_attach" :href="grantAllowanceServiceBaseUrl + 'storage'+ '/grant-panel' + '/institution-registration/' + profile.last_audit_attach"
                                                target="_blank" rel="noopener noreferrer">{{ profile.last_audit_attach }}<i class="ri-download-cloud-line" ></i>
                                                </a>
                                                </b-td>
                                            </b-tr>
                                        </tbody>
                                    </b-table-simple>
                                    <b-table-simple v-if="profile.documents.length > 0" striped bordered small hover>
                                        <thead class="text-white bg-primary">
                                            <tr>
                                                <th class="text-center" width="150px">{{ $t('globalTrans.sl_no') }}</th>
                                                <th class="text-center">{{ $t('grant_registration.document_title') }}</th>
                                                <th class="text-center">{{ $t('grant_registration.document') }}</th>
                                                <th class="text-center">{{ $t('externalUser.comments') }}</th>
                                            </tr>
                                        </thead>
                                        <b-tbody>
                                            <b-tr v-for="(item, index) in profile.documents" :key="index">
                                                <b-td class="text-center">{{ $n(index + 1) }}</b-td>
                                                <b-td class="text-center">{{ item.title }}</b-td>
                                                <b-td class="text-center">
                                                    <a v-if="item.attachment" :href="url + 'storage/grant-panel/institution-registration/' + item.attachment" target="_blank">
                                                        {{ item.attachment.split('/').pop() }}
                                                        <i class="ri-download-cloud-line" ></i>
                                                    </a>
                                                </b-td>
                                                <b-td class="text-center">{{ (currentLocale === 'en') ? item.comment : item.comment_bn }}</b-td>
                                            </b-tr>
                                        </b-tbody>
                                    </b-table-simple>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import ExportPdf from '../application_details_pdf'
import RestApi, { grantAllowanceServiceBaseUrl, commonServiceBaseUrl } from '@/config/api_config'
import Custom from '../../../../../store/custom'

export default {
    props: ['id'],
    data () {
        return {
            profile: {},
            url: grantAllowanceServiceBaseUrl,
            bankName: '',
            branchName: ''
        }
    },
    created () {
        if (this.id) {
            const tmp = this.getApplicationFormData()
            this.profile = tmp
        }
    },
    computed: {
      currentLocale: function () {
        return this.$i18n.locale
      }
    },
    watch: {
        'profile.bank_id': function (newVal, oldVal) {
            if (this.profile.bank_id > 0) {
                this.getBankName(newVal)
            }
        },
        'profile.branch_id': function (newVal, oldVal) {
            if (this.profile.branch_id > 0) {
                this.getBranchName(newVal)
            }
        }
    },
    methods: {
        async getBankName (Id) {
            const objectData = await RestApi.getData(commonServiceBaseUrl, 'common/bank-name', { id: Id })
            this.bankName = this.$i18n.locale === 'bn' ? objectData.text_bn : objectData.text_en
        },
        async getBranchName (Id) {
            const objectData = await RestApi.getData(commonServiceBaseUrl, 'common/branch-name', { id: Id })
            this.branchName = this.$i18n.locale === 'bn' ? objectData.text_bn : objectData.text_en
        },
        getAnswerName (Id) {
            const objectData = this.$store.state.commonObj.answerList.find(item => item.value === parseInt(Id))
            if (this.$i18n.locale === 'bn') {
                return objectData.text_bn
            } else {
                return objectData.text_en
            }
        },
        getOfficeType (Id) {
            const tmpData = this.$store.state.commonObj.officeTypeList.find(item => item.value === Id && item.status === 0)
            if (this.$i18n.locale === 'bn') {
                return tmpData.text_bn
            } else {
                return tmpData.text_en
            }
        },
        getOfficeName (Id) {
            const tmpData = this.$store.state.commonObj.officeList.find(item => item.value === Id && item.status === 0)
            if (this.$i18n.locale === 'bn') {
                return tmpData.text_bn
            } else {
                return tmpData.text_en
            }
        },
        getInstituteType (Id) {
            const instituteType = this.$store.state.commonObj.instituteType.find(item => item.value === parseInt(Id))
            if (this.$i18n.locale === 'bn') {
                return instituteType.text_bn
            } else {
                return instituteType.text_en
            }
        },
        getWardName (Id) {
            const tmpData = this.$store.state.commonObj.wardList.find(item => item.value === Id && item.status === 0)
            if (this.$i18n.locale === 'bn') {
                return tmpData.text_bn
            } else {
                return tmpData.text_en
            }
        },
        getUnionName (Id) {
            const tmpData = this.$store.state.commonObj.unionList.find(item => item.value === Id && item.status === 0)
            if (this.$i18n.locale === 'bn') {
                return tmpData.text_bn
            } else {
                return tmpData.text_en
            }
        },
        getUpazilaName (Id) {
            const tmpData = this.$store.state.commonObj.upazilaList.find(item => item.value === Id && item.status === 0)
            if (this.$i18n.locale === 'bn') {
                return tmpData.text_bn
            } else {
                return tmpData.text_en
            }
        },
        getDivisionName (Id) {
            const tmpData = this.$store.state.commonObj.divisionList.find(item => item.value === Id && item.status === 0)
            if (this.$i18n.locale === 'bn') {
                return tmpData.text_bn
            } else {
                return tmpData.text_en
            }
        },
        getPourosobaName (Id) {
            const tmpData = this.$store.state.commonObj.pauroshobaList.find(item => item.value === Id && item.status === 0)
            if (this.$i18n.locale === 'bn') {
                return tmpData.text_bn
            } else {
                return tmpData.text_en
            }
        },
        getCityCorpName (Id) {
            const tmpData = this.$store.state.commonObj.cityCorporationList.find(item => item.value === Id && item.status === 0)
            if (this.$i18n.locale === 'bn') {
                return tmpData.text_bn
            } else {
                return tmpData.text_en
            }
        },
        getDistrictName (Id) {
            const tmpData = this.$store.state.commonObj.districtList.find(item => item.value === Id && item.status === 0)
            if (this.$i18n.locale === 'bn') {
                return tmpData.text_bn
            } else {
                return tmpData.text_en
            }
        },
        getAreaType (Id) {
            const tmpData = Custom.wardTypeList.find(item => item.id === parseInt(Id))
            if (this.$i18n.locale === 'bn') {
                return tmpData.name_bn
            } else {
                return tmpData.name
            }
        },
        pdfExport () {
            const reportTitle = this.$t('grant_registration.archived_application_list') + ' ' + this.$t('globalTrans.details')
            ExportPdf.exportPdfDetails(grantAllowanceServiceBaseUrl, 'configuration/report-heading/detail', this.profile.org_id, reportTitle, this.profile, this)
        }
    }
}
</script>
<style lang="scss">
    .details {
    h5 {
      color: green !important;
      font-size: 20px !important;
    }
    .table-bordered td:nth-child(2n+1) {
      font-weight: 700;
    }
  }
  .hidden_header {
    display: none
  }
  [dir=ltr][mode=light] .card-body {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 10px;
  }
</style>
